/**
 * @generated SignedSource<<058409b2e1f70bd1e68fe9b321f455fc>>
 * @relayHash b8a15b0a523ce23e2e2f3255d7a4c802
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 61f7c1d7fbecd4f80c57220be7e22b9dcfcffbb74551b732dd98a98867eaea99

var node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hubAri"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageAri"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }],
    v2 = [{
      "kind": "Variable",
      "name": "helpCenterAri",
      "variableName": "hubAri"
    }],
    v3 = {
      "kind": "ScalarField",
      "name": "__typename"
    },
    v4 = {
      "kind": "ScalarField",
      "name": "id"
    },
    v5 = {
      "kind": "InlineFragment",
      "selections": [{
        "args": [{
          "fields": [{
            "items": [{
              "kind": "Variable",
              "name": "ids.0",
              "variableName": "pageAri"
            }],
            "kind": "ListValue",
            "name": "ids"
          }],
          "kind": "ObjectValue",
          "name": "filter"
        }],
        "concreteType": "HelpCenterPage",
        "kind": "LinkedField",
        "name": "pages",
        "plural": true,
        "selections": [v4 /*: any*/, {
          "concreteType": "HelpCenterPageLayout",
          "kind": "LinkedField",
          "name": "pageLayout",
          "plural": false,
          "selections": [{
            "concreteType": "HelpCenterLayoutAdf",
            "kind": "LinkedField",
            "name": "layoutAdf",
            "plural": false,
            "selections": [{
              "concreteType": "HelpCenterLayoutAdfContentConnection",
              "kind": "LinkedField",
              "name": "content",
              "plural": false,
              "selections": [{
                "concreteType": "HelpCenterLayoutAdfContentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [{
                  "concreteType": "HelpCenterLayoutAdfContent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [{
                    "kind": "ScalarField",
                    "name": "content"
                  }]
                }]
              }]
            }]
          }]
        }]
      }, {
        "concreteType": "HelpCenterBranding",
        "kind": "LinkedField",
        "name": "helpCenterBranding",
        "plural": false,
        "selections": [{
          "concreteType": "HelpCenterBrandingColors",
          "kind": "LinkedField",
          "name": "colors",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "name": "primary"
          }]
        }]
      }],
      "type": "HelpCenter"
    },
    v6 = {
      "kind": "InlineFragment",
      "selections": [{
        "kind": "ScalarField",
        "name": "message"
      }],
      "type": "QueryError"
    },
    v7 = [{
      "kind": "Literal",
      "name": "type",
      "value": "SUPPORT_SITE"
    }],
    v8 = {
      "kind": "InlineFragment",
      "selections": [v4 /*: any*/, {
        "concreteType": "CsmAiWidgetBrandingTheme",
        "kind": "LinkedField",
        "name": "theme",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "name": "colorVibeVariant"
        }, {
          "kind": "ScalarField",
          "name": "space"
        }, {
          "kind": "ScalarField",
          "name": "radius"
        }, {
          "kind": "ScalarField",
          "name": "chatColor"
        }]
      }, {
        "kind": "ScalarField",
        "name": "position"
      }, {
        "kind": "ScalarField",
        "name": "isEnabled"
      }],
      "type": "CsmAiWidgetConfig"
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "name": "hubQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v2 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v3 /*: any*/, v5 /*: any*/, v6 /*: any*/]
        }]
      }, {
        "args": v2 /*: any*/,
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [{
          "kind": "InlineFragment",
          "selections": [v4 /*: any*/, {
            "args": v7 /*: any*/,
            "kind": "LinkedField",
            "name": "widgets",
            "plural": true,
            "selections": [v8 /*: any*/],
            "storageKey": "widgets(type:\"SUPPORT_SITE\")"
          }],
          "type": "CsmAiHub"
        }]
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "hubQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v2 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v3 /*: any*/, v5 /*: any*/, v6 /*: any*/, {
            "kind": "InlineFragment",
            "selections": [v4 /*: any*/],
            "type": "Node",
            "abstractKey": "__isNode"
          }]
        }]
      }, {
        "args": v2 /*: any*/,
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [v3 /*: any*/, {
          "kind": "InlineFragment",
          "selections": [v4 /*: any*/, {
            "args": v7 /*: any*/,
            "kind": "LinkedField",
            "name": "widgets",
            "plural": true,
            "selections": [v3 /*: any*/, v8 /*: any*/],
            "storageKey": "widgets(type:\"SUPPORT_SITE\")"
          }],
          "type": "CsmAiHub"
        }]
      }]
    },
    "params": {
      "id": "61f7c1d7fbecd4f80c57220be7e22b9dcfcffbb74551b732dd98a98867eaea99",
      "metadata": {},
      "name": "hubQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "8850d7a1cfd52c49fe1c321d3f3abd49";
export default node;